<template>
  <div>
    <h1>Информация о директоре ДО</h1>
    <template v-if="hasAccess([...adminRoles, ...managerRoles]) && kindergartenHead">
      <button v-if="!isLoading" class="reset-btn" @click="resetPassword(kindergartenHead.userInfo?.id)">Сбросить пароль</button>
      <button v-else disabled class="reset-btn-disabled">Загрузка...</button>
    </template>
    <div v-if="kindergartenHead">
      <h2>Информация о пользователе</h2>
      <p><strong>ID пользователя:</strong> {{ kindergartenHead.userInfo.id }}</p>
      <p><strong>Имя:</strong> {{ kindergartenHead.userInfo.firstName }}</p>
      <p><strong>Фамилия:</strong> {{ kindergartenHead.userInfo.lastName }}</p>
      <p><strong>Имя пользователя:</strong> {{ kindergartenHead.userInfo.username }}</p>
      <p><strong>ИИН:</strong> {{ kindergartenHead.userInfo.userAttributes[UserAttribute.IIN] }}</p>

        <button v-if="hasAccess([...adminRoles, ...managerRoles])" class="btn btn-warning" @click="openEditKindergartenHead">Внести изменение в Директора ДО</button>

      <div v-if="showEditKindergartenHead" class="modal">
        <div class="modal-content">
          <h2>Добавить директора ДО</h2>
          <form @submit.prevent="handleSubmitUpdateKindergartenHead">
            <div class="form-group">
              <label for="firstName">Имя:</label>
              <input type="text" id="firstName" v-model="firstName" required />
            </div>

            <div class="form-group">
              <label for="lastName">Фамилия:</label>
              <input type="text" id="lastName" v-model="lastName" required />
            </div>

            <div class="form-group">
              <label for="iin">ИИН:</label>
              <input type="text" id="iin" v-model="iin" required />
            </div>

            <div class="form-group">
              <label for="lmsId">LMS система:</label>
              <multiselect
                  v-model="selectedLms"
                  :options="lmsSystems"
                  label="lmsId"
                  placeholder="Выберите LMS систему"
                  :searchable="true"
                  :clear-on-select="true"
                  :close-on-select="true"
                  :allow-empty="true"
              />
            </div>

            <button type="submit" class="submit-btn" :disabled="isLoading">
              {{ isLoading ? 'Сохранение...' : 'Сохранить' }}
            </button>
          </form>
          <button class="close-modal-btn" @click="closeModal">Закрыть</button>
        </div>
      </div>

      <h2>Информация о LMS системе</h2>
      <p><strong>ID LMS:</strong> {{ kindergartenHead.lmsSystem?.lmsId }}</p>
      <p><strong>Группа региона:</strong> {{ kindergartenHead.lmsSystem?.regionGroup?.code }}</p>
      <p><strong>Тип населенного пункта:</strong> {{ kindergartenHead.lmsSystem?.localityType?.name }}</p>
      <p><strong>Населенный пункт:</strong> {{ kindergartenHead.lmsSystem?.kato?.nameRu }}</p>
      <p><strong>Физический адрес:</strong> {{ kindergartenHead.lmsSystem?.address }}</p>
      <p><strong>Номер договора и дата:</strong> {{ kindergartenHead.lmsSystem?.contractNumberAndDate }}</p>

      <h2>Информация о ДО</h2>
      <p v-if="kindergartenHead.lmsSystem.kindergartenDocumentInfo">
        <strong>БИН ДО:</strong> {{ kindergartenHead.lmsSystem.kindergartenDocumentInfo.bin }}
      </p>
      <p v-if="kindergartenHead.lmsSystem.kindergartenDocumentInfo">
        <strong>Наименование ДО:</strong> {{ kindergartenHead.lmsSystem.kindergartenDocumentInfo.name }}
      </p>
      <p v-if="kindergartenHead.lmsSystem.kindergartenDocumentInfo">
        <strong>Тип собственности:</strong> {{ kindergartenHead.lmsSystem.kindergartenDocumentInfo.ownershipType?.name }}
      </p>
      <button class="open-modal-btn" @click="openModal">Выгрузить расчет</button>

      <div v-if="showModal" class="modal">
        <div class="modal-content">
          <h2>Выберите месяц и год</h2>
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="accountingMonth">Месяц:</label>
              <input type="number" id="accountingMonth" v-model="accountingMonth" min="1" max="12" required />
            </div>

            <div class="form-group">
              <label for="accountingYear">Год:</label>
              <input type="number" id="accountingYear" v-model="accountingYear" min="2000" required />
            </div>

            <p><strong>БИН:</strong> {{ kindergartenHead.lmsSystem.kindergartenDocumentInfo?.bin }}</p>
            <p><strong>ID LMS:</strong> {{ kindergartenHead.lmsSystem?.lmsId }}</p>

            <button type="submit" class="submit-btn" :disabled="isLoading">
              {{ isLoading ? 'Выгружается...' : 'Выгрузить' }}
            </button>
          </form>
          <button class="close-modal-btn" @click="closeModal">Закрыть</button>
        </div>
      </div>

      <div v-if="calculationReports.length > 0">
        <h2>Отчеты о расчетах</h2>
        <table class="calculation-reports-table">
          <thead>
          <tr>
            <th>ID</th>
            <th>Не подписанный расчет</th>
            <th>Расчетный месяц</th>
            <th>Расчетный год</th>
            <th>Статус</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="calculationReport in sortedReports" :key="calculationReport.id">
            <td>{{ calculationReport.id }}</td>
            <td>
              <span v-if="calculationReport.report.reportStatus==='GENERATING'">
                {{ calculationReport.report.fileName ?? 'N/A' }}
              </span>
              <a
                  v-else
                  @click="handleDownload(calculationReport.report.uuid, calculationReport.report.fileName)"
                  :class="{ 'active-link': calculationReport.report?.reportStatus === 'GENERATED', 'error-link': calculationReport.report?.reportStatus === 'ERROR' }"
              >
                {{ calculationReport.report.fileName ?? 'N/A' }}
              </a>
            </td>
            <td>{{ calculationReport.accountingMonth }}</td>
            <td>{{ calculationReport.accountingYear }}</td>
            <td>
              <span v-if="calculationReport.report?.reportStatus==='ERROR'">Неизвестная ошибка</span>
              <span v-if="calculationReport.report?.reportStatus==='GENERATING'">Выгружается</span>
              <span v-else-if="calculationReport.signStatus === 'SIGNED'">Подписан</span>
              <span v-else-if="calculationReport.signStatus === 'NOT_SIGNED'">Не подписан</span>
              <span v-else-if="calculationReport.signStatus === 'REJECTED_BY_HEAD'">
                <span class="reject-status">Отказано от Директора ДО</span>
                <br>
                {{ calculationReport.rejectComment }}
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>


    </div>

    <div v-else-if="isLoading">
      <p>Загрузка информации...</p>
    </div>
    <div v-else-if="error">
      <p>Ошибка при загрузке информации: {{ error }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import {findById, resetToDefault, updateUser} from '@/services/userService';
import {
  downloadReportFile,
  generateCalculationReport,
  kindergartenCalculationReportList
} from "@/services/reportService";
import {KindergartenHeadItem, UserInfoDTO} from '@/types/user';
import { CalculationReportResponse, KindergartenCalculationReport } from "@/types/report";
import { useRoute } from 'vue-router';
import {UserAttribute} from "@/contants";
import authService from "@/services/authService";
import { ElMessage } from 'element-plus';
import Multiselect from "vue-multiselect";
import {LmsSystemItem} from "@/types/kindergarten";
import {getLmsSystems} from "@/services/directoryService";

export default defineComponent({
  components: {Multiselect},
  computed: {
    UserAttribute() {
      return UserAttribute
    }
  },
  setup() {
    const kindergartenHead = ref<KindergartenHeadItem | null>(null);
    const calculationReports = ref<KindergartenCalculationReport[]>([]);
    const isLoading = ref(false);
    const error = ref('');
    const showModal = ref(false);
    const showEditKindergartenHead = ref(false);
    const accountingMonth = ref<number | null>(null);
    const accountingYear = ref<number | null>(null);
    const route = useRoute();
    const kindergartenHeadId: string = Array.isArray(route.params.id) ? route.params.id[0] : route.params.id;
    const adminRoles: string[] = authService.getAdminRoles();
    const managerRoles: string[] = authService.getManagerRoles();
    const hasAccess = authService.hasAccess;
    const firstName = ref("");
    const lastName = ref("");
    const iin = ref("");
    const lmsSystems = ref<LmsSystemItem[]>([]);
    const selectedLms = ref<LmsSystemItem | null>(null);

    const fetchCalculationReports = async () => {
      isLoading.value = true;
      try {
        const token = localStorage.getItem('access_token');
        if (token) {
          kindergartenHead.value = await findById(token, kindergartenHeadId);
          if (kindergartenHead.value?.lmsSystem?.lmsId) {
            calculationReports.value = await kindergartenCalculationReportList(token, kindergartenHead.value.lmsSystem.lmsId);
          }
        }
      } catch (e) {
        error.value = 'Не удалось загрузить информацию.';
        console.error(e);
      } finally {
        isLoading.value = false;
      }
    };

    const openEditKindergartenHead = () => {
      if (kindergartenHead.value) {
        // Заполняем форму текущими данными
        firstName.value = kindergartenHead.value.userInfo.firstName;
        lastName.value = kindergartenHead.value.userInfo.lastName;
        iin.value = kindergartenHead.value.userInfo.userAttributes[UserAttribute.IIN];
        selectedLms.value = kindergartenHead.value.lmsSystem;
      }
      showEditKindergartenHead.value = true; // Открытие модального окна
    };

    onMounted(() => {
      fetchCalculationReports();
      fetchLmsSystems();
    });

    const openModal = () => {
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
      accountingMonth.value = null;
      accountingYear.value = null;
      showEditKindergartenHead.value = false;
    };

    const handleSubmit = async () => {
      isLoading.value = true;
      try {
        const token = localStorage.getItem('access_token');
        if (token && kindergartenHead.value && accountingMonth.value && accountingYear.value) {
          const requestData: CalculationReportResponse = {
            accountingMonth: accountingMonth.value,
            accountingYear: accountingYear.value,
            binListStr: kindergartenHead.value.lmsSystem.kindergartenDocumentInfo?.bin || '',
            lmsIdListStr : kindergartenHead.value.lmsSystem?.lmsId?.toString() || ''
          };
          await generateCalculationReport(token, requestData);
        }
        closeModal();
        await fetchCalculationReports();
      } catch (error) {
        console.error("Ошибка при выгрузке расчета:", error);
      } finally {
        isLoading.value = false;
      }
    };

    const handleSubmitUpdateKindergartenHead = async () => {
      isLoading.value = true;

      try {
        const token = localStorage.getItem("access_token");
        if (token && kindergartenHead.value && selectedLms.value && 'id' in selectedLms.value) {
          const lmsSystem: LmsSystemItem = selectedLms.value;
          const userAttributes: Record<string, string> = {};
          userAttributes[UserAttribute.LMS_ID] = lmsSystem.lmsId;
          userAttributes[UserAttribute.IIN] = iin.value;
          // Создаём объект с обновлёнными данными
          const updatedUserInfo: UserInfoDTO = {
            ...kindergartenHead.value.userInfo, // Копируем текущие данные
            firstName: firstName.value, // Обновляем имя
            lastName: lastName.value, // Обновляем фамилию
            userAttributes: userAttributes
          };
          await updateUser(token, updatedUserInfo).then(() => {
            fetchCalculationReports();
          });
        }
        closeModal();
      } catch (error) {
        console.error("Ошибка при создании директора ДО:", error);
      } finally {
        isLoading.value = false;
      }
    };

    const resetPassword = async (userId: string) => {
      isLoading.value = true;
      await resetToDefault(userId);
      ElMessage.success("Пароль был успешно сброшен на '123456' ");
      isLoading.value = false;
    }

    const sortedReports = computed(() => {
      return calculationReports.value.slice().sort((a, b) => b.id - a.id);
    });

    const handleDownload = async (fileId: string, fileName: string) => {
      try {
        const token = localStorage.getItem("access_token");
        if (token) {
          await downloadReportFile(token, fileId, fileName);
        }
      } catch (error) {
        console.error("Ошибка при скачивании файла:", error);
      }
    };

    const fetchLmsSystems = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (token) {
          lmsSystems.value = await getLmsSystems(token);
        }
      } catch (error) {
        console.error("Ошибка при получении данных:", error);
      }
    }

    return {
      kindergartenHead,
      calculationReports,
      isLoading,
      error,
      showModal,
      accountingMonth,
      accountingYear,
      openModal,
      closeModal,
      handleSubmit,
      sortedReports,
      handleDownload,
      adminRoles,
      managerRoles,
      hasAccess,
      resetPassword,
      showEditKindergartenHead,
      handleSubmitUpdateKindergartenHead,
      openEditKindergartenHead,
      lmsSystems,
      selectedLms,
      iin,
      lastName,
      firstName,
      fetchLmsSystems
    };
  },
});
</script>

<style scoped>
h1 {
  text-align: center;
  margin-top: 20px;
}

h2 {
  margin-top: 15px;
}

p {
  font-size: 16px;
  margin: 5px 0;
}

.reset-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.reset-btn-disabled {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: gray;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.submit-btn, .close-modal-btn {
  display: block;
  margin: 10px 0;
  padding: 10px;
  width: 100%;
  cursor: pointer;
}

.submit-btn {
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
}

.close-modal-btn {
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.calculation-reports-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.calculation-reports-table th,
.calculation-reports-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.calculation-reports-table th {
  background-color: #4CAF50;
  color: white;
}

.active-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

.active-link:hover {
  text-decoration: underline;
}

.error-link {
  color: red;
}

.reject-status {
  color: red;
}
</style>
